import React, { useContext, Suspense } from 'react';
import { Route, ScrollToTop, Switch } from '@thd-olt-component-react/router';
import { string, func } from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { DataProvider } from '@thd-nucleus/data-sources';
import './styles/global-styles.scss';
import { Error } from './pages';
import { getRoutes } from './routes';
import './styles/app.scss';

const browseBatchedDomains = {
  search: [
    'appliedDimensions',
    'relatedResults',
    'orangeGraph',
    'dimensions',
    'templates'
  ]
};

export const App = ({ currentRouteName, currentRouteComponent }) => {
  const routes = getRoutes(currentRouteName, currentRouteComponent);
  const { channel, store = {} } = useContext(ExperienceContext);

  return (
    <>
      <ScrollToTop />
      <Switch>
        <Route path={routes.browse.path}>
          <DataProvider batchedDomains={browseBatchedDomains}>
            <routes.browse.component pageType="browse" />
          </DataProvider>
        </Route>
        <Route path={routes.search.path}>
          <DataProvider batchedDomains={browseBatchedDomains}>
            <routes.search.component pageType="search" />
          </DataProvider>
        </Route>
        <Route exact path={routes.pep.path}>
          {channel !== 'mobile' && <routes.pep.component />}
          {channel === 'mobile' && <routes.pepMobile.component />}
        </Route>
        <Route exact path={routes.product.path}>
          <routes.product.component />
        </Route>
        <Route exact path={routes.compare.path}>
          <DataProvider batchedDomains={{}}>
            <routes.compare.component />
          </DataProvider>
        </Route>
        <Route exact path={routes.home.path}>
          <routes.home.component />
        </Route>
        <Route path="/error">
          <Error />
        </Route>
        <Route>
          <Error />
        </Route>
      </Switch>
    </>
  );
};

App.propTypes = {
  currentRouteName: string,
  currentRouteComponent: func
};

App.defaultProps = {
  currentRouteName: null,
  currentRouteComponent: null
};
